/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc
 */
import * as References from './DealPlanEngagementTrackingPortalRpc';
import { createRpcClientV2 } from 'rpc-client-utils';
import portalsHttpClient from 'portals-platform-lib/portalsHttpClient';
import { registerMutation } from 'data-fetching-client/next';
const chirpClient = createRpcClientV2({
  hubHttpClient: portalsHttpClient
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc#trackPlanVisited
 */
export const TRACK_PLAN_VISITED_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanEngagementTrackingPortalRpc_trackPlanVisited';
export const TRACK_PLAN_VISITED_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: TRACK_PLAN_VISITED_MUTATION_FIELD_NAME,
  args: ['membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.trackPlanVisitedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.deal.plans.rpc.DealPlanEngagementTrackingPortalRpc#trackLinkShared
 */
export const TRACK_LINK_SHARED_MUTATION_FIELD_NAME = 'com_hubspot_deal_plans_rpc_DealPlanEngagementTrackingPortalRpc_trackLinkShared';
export const TRACK_LINK_SHARED_MUTATION = /* #__PURE__ */registerMutation({
  fieldName: TRACK_LINK_SHARED_MUTATION_FIELD_NAME,
  args: ['dealPlanId', 'sharedToContactVid', 'membershipToken', 'utkCookie', 'portalInstanceId', 'accountId', 'objectId', 'membershipCsrfTokenFromClient', 'membershipCsrfTokenFromCookie', 'previewJwt', 'companyId', 'tolerateInstanceAccessDenied'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.trackLinkSharedRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});